/* eslint-disable @typescript-eslint/naming-convention */
import { useSignal } from "@preact/signals-react"

import Icon from './Icon.jsx'

import { debugSignal } from '../state/signals/userSettingsSignals.js'

const SetMembershipCheckbox = ({ id, checkboxId, selectedEntitySetSignal, enableSubmitSignal }) => {

	const debug = debugSignal.value

	const checkedSignal = useSignal(selectedEntitySetSignal.value && selectedEntitySetSignal.value.has(id))

	const toggleChecked = (event) => {
		if (checkedSignal.value) {
			//console.log(`Unchecking ${id}`)
			checkedSignal.value = false
			if (selectedEntitySetSignal.value) {
				selectedEntitySetSignal.value.delete(id)
				if (enableSubmitSignal) {
					if (selectedEntitySetSignal.value.size == 0) {
						enableSubmitSignal.value = false
						//console.log("Disabled submit")
					}
				}
			}
		}
		else {
			//console.log(`Checking ${id}`)
			checkedSignal.value = true
			if (selectedEntitySetSignal.value) {
				selectedEntitySetSignal.value.add(id)
			}
			if (enableSubmitSignal) {
				enableSubmitSignal.value = true
			}
			//console.log("Enabled submit")
		}
		//event.stopPropagation()
		/*if (selectedEntitySetSignal) {
			console.log("After clicking, the following entities are selected:")
			console.log(selectedEntitySetSignal.value)
		}*/
	}

    return (<>
		{/*<input type="checkbox" id={checkboxId} hidden={!debug ? "hidden" : undefined} /*className="SetMembershipCheckbox"*\/ onChange={toggleChecked} />*/}
		{debug && (<>{id}&nbsp;</>)}
		<label htmlFor={checkboxId} data-display-state="off" hidden={checkedSignal.value} onClick={toggleChecked}>
			<Icon style={{ fontSize: "28px", color: "#ccc" }} icon="check-square" />{ debug && (<>&nbsp;Off</>) }
		</label>
		<label htmlFor={checkboxId} data-display-state="on" hidden={!checkedSignal.value} onClick={toggleChecked}>
			<Icon style={{ fontSize: "28px", color: "#6f2a8e" }} icon="check-square-fill" />{debug && (<>&nbsp;On</>)}
		</label>
	</>)
}

export default SetMembershipCheckbox